require('jquery-countdown');

let $clock = $('.js-countdown');
$(document).ready(function () {
    if ($clock.length > 0) {
        let countdown = $clock.data('expire');

        $clock.countdown(countdown).on('update.countdown', function (event) {
            let weeks = parseInt(event.strftime('%-w'), 10);
            if (weeks > 0) {
                $clock.find('#weeks .__digit').html(weeks);
                $clock.find('#weeks .__label').html(event.strftime('Week%!w'));
            } else {
                $clock.find('#weeks').remove();
            }

            let days = parseInt(event.strftime('%-d'), 10);
            if (days === 0) {
                $clock.find('#days .__digit').html('0');
            } else {
                $clock.find('#days .__digit').html(days);
                $clock.find('#days .__label').html(event.strftime('Day%!d'));
            }

            let hours = parseInt(event.strftime('%H'), 10);
            if (hours === 0) {
                $clock.find('#hours .__digit').html('0');
            } else {
                $clock.find('#hours .__digit').html(hours);
                $clock.find('#hours .__label').html(event.strftime('Hour%!H'));
            }

            let minutes = parseInt(event.strftime('%M'), 10);
            if (minutes === 0) {
                $clock.find('#minutes .__digit').html(0);
            } else {
                $clock.find('#minutes .__digit').html(minutes);
                $clock.find('#minutes .__label').html(event.strftime('Minute%!M'));
            }

            let seconds = parseInt(event.strftime('%S'), 10);
            if (seconds === 0) {
                $clock.find('#seconds .__digit').html(0);
            } else {
                $clock.find('#seconds .__digit').html(seconds);
                $clock.find('#seconds .__label').html(event.strftime('Second%!S'));
            }

            $clock.removeClass('d-none');
        });
    }
});
